export default __webpack_public_path__ + "static/media/tutorial1-2.0ab1078f.png";